import React, { Component } from 'react';
import './Style.css';
import '../../../custom.css'
import { Alert } from '../../Utils/Alert';
import { Loading } from '../../Utils/Loading';
import NotFound from '../../../images/empty.svg'

export class CommunityLife extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPost: false,
            loading: false,
            friendsList: [],
            indexPage: 1,
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            }
        }
    }

    componentDidMount() {
        this.GetCommunity();
    }

    async GetCommunity() {
        var request = {
            method: 'GET',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Users/GetCommunityPl?indexPage=${this.state.indexPage}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            this.setState((prevState) => ({
                friendsList: [...prevState.friendsList, ...data.result]
            }));
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No se puede cargar la comunidad.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    async followSave(friendId, control) {
        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json', 'Authorization': `bearer ${localStorage.getItem('token')}` },
            //body: JSON.stringify(this.state.model)
        }

        this.setState({ loading: true });

        const response = await fetch(`Friends/FollowInsert?FriendId=${friendId}`, request);

        this.setState({ loading: false });

        if (response.status == 401) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'No tiene permisos para ver está página',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }

        if (response.status == 200) {
            const data = await response.json();
            if (data.isSuccess) {
                this.setState({
                    alert: {
                        Title: 'Éxito',
                        Body: `Ya estas siguiendo a ${this.state.followName}`,
                        Type: 'alert-success',
                        Show: true
                    }
                });
                document.querySelector(control).disabled = true;
                document.querySelector(control).value = 'Siguiendo';
            } else {
                this.setState({
                    alert: {
                        Title: 'Error',
                        Body: `Siguiendo a ${this.state.followName}`,
                        Type: 'alert-danger',
                        Show: true
                    }
                });
            }
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: `Siguiendo a ${this.state.followName}`,
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }

    render() {

        return (
            <div className="wrapp-friends row">


                <div className="mt-5 text-center">
                    <h2 className="">Comunidad</h2>
                </div>
                {this.state.friendsList.map((e, i) =>
                    <div className="col-lg-3 text-center mt-5">
                        <div className="community-photo">

                            {e.photo ? <img src={e.photo} className="" /> : <img src={require('../../../images/avatar.png')} />}

                            
                        </div>
                        <div className="mt-2">
                            <h6>{e.name}</h6>
                        </div>
                        <div className="mt-2">
                            {
                                !e.already ? <input type="button" id={`btnFollow${i}`} value="Seguir" className="btn btn-primary" onClick={(event) => {
                                    this.followSave(e.userId, `#btnFollow${i}`);
                                    this.setState({ followName: e.name });
                                }
                                } /> :
                                    <input type="button" disabled="true" value="Siguiendo" className="btn btn-primary" />
                            }
                            <a href={`/comunidad/mi-perfil?optional=${e.userId}`} className="btn mt-2">Ver perfil</a>

                        </div>
                    </div>

                )}

                {
                    this.state.friendsList.length > 0 ?
                        <div className="align-middle text-center">
                            <input type="button" value="Cargar más" className="btn btn-primary" onClick={() => {
                                this.setState((prevState) => ({ indexPage: prevState.indexPage + 1 }), () => {
                                    this.GetCommunity();
                                });
                            }} />
                        </div> :
                        null
                }

                {
                    this.state.friendsList.length == 0 ?
                        <div className="align-middle text-center">
                            <img className="not-found" src={NotFound} />
                            <h5 className="mt-3">No hay pl´s activos</h5>
                        </div> :
                        null
                }




                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }}/> : null}
                {this.state.loading ? <Loading /> : null}
            </div>
        );
    }
}
